export const oldPlanContentItems = [
  'Energy Management',
  'Data Visualization',
  'AI Scheduler',
  'Energy Boost',
  'Unlimited To-Dos',
  'Unlimited Calendars',
  'Unlimited Wearables',
  'Mobile, Web, Chrome Add-On',
];

export const planContentItems: string[] = [
  'Understand my energy levels',
  'Reduce stress and prevent burnout',
  'Achieve better work life balance',
  'Improve my productivity',
  'Focus on my mental wellbeing',
];
